'use client';

import React from 'react';
import { useTheme } from '@/components/ThemeContext';

interface PanelProps {
    icon: React.ReactNode;
    title: string;
    actions?: React.ReactNode;
    children: React.ReactNode;
    className?: string;
}

export default function Panel({ icon, title, actions, children, className = '' }: PanelProps) {
    const { theme } = useTheme();
    const isDark = theme === 'dark';
    return (
        <div className={`border rounded-xl overflow-hidden ${isDark ? 'bg-white/[0.02] border-white/[0.08]' : 'bg-white border-gray-200 shadow-sm'} ${className}`}>
            <div className={`px-4 py-3 border-b text-sm font-semibold flex items-center gap-2 ${isDark ? 'border-white/[0.08] bg-white/[0.02]' : 'border-gray-100 bg-gray-50 text-gray-800'}`}>
                {icon} {title}{actions && <div className="ml-auto flex gap-1">{actions}</div>}
            </div>
            {children}
        </div>
    );
}
